import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Spinner } from 'react-redux-spinner';
import LogoutWarning from '../../components/LogoutWarning';
import ScrollToTop from '../../components/ScrollToTop';
import DashboardPage from '../PageDashboard';

// Application Styles
import './App.scss';

const GlobalSetup = lazy(() => import('../PageGlobalSetup'));

/**  It needs a spinner considering the lazy import */
const GlobalSetupPageWithSpinner = () => (
    <Suspense fallback={<Spinner config={{ easing: 'ease', speed: 1000 }} />}>
        <GlobalSetup />
    </Suspense>
);

const App = () => (
    <div className="app-admin">
        <LogoutWarning />
        <ScrollToTop />
        <Routes>
            <Route
                path=""
                element={<DashboardPage />}
            />
            {/* TODO - use regex to avoid code duplicate */}
            <Route
                path="/AwardingRules"
                element={<DashboardPage />}
            />
            <Route
                path="/GlobalSetup"
                element={<GlobalSetupPageWithSpinner />}
            />
        </Routes>
    </div>
);

export default App;
